import React from 'react'
import { colors } from '../../theme'

type IntegracaoProps = {
  ativo?: boolean
}

function Integracao({ ativo }: IntegracaoProps) {
  const fill = ativo ? colors.secondary : colors.grey600
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M5 10.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM2.25 12a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0zM19 3.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM16.25 5a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0zM19 10.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM16.25 12a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0zM19 17.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM16.25 19a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0z"
        clipRule="evenodd"
      />
      <path
        fill={fill}
        fillRule="evenodd"
        d="M10.25 5a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-5.25v12.5H17a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75V5z"
        clipRule="evenodd"
      />
      <path
        fill={fill}
        fillRule="evenodd"
        d="M6.25 12a.75.75 0 01.75-.75h10a.75.75 0 010 1.5H7a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default Integracao
